
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"240","height":"240","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 220c55.228 0 100-44.772 100-100S175.228 20 120 20 20 64.772 20 120s44.772 100 100 100z","stroke":"#BEBFC4","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M79.652 79.13H67.826a13.043 13.043 0 00-13.043 13.044v64.348a13.043 13.043 0 0013.043 13.043h102.261l-26.685-26.685c-5.734 6.449-14.094 10.511-23.402 10.511-17.289 0-31.304-14.015-31.304-31.304 0-9.308 4.062-17.668 10.511-23.402L79.652 79.13zm69.399 54.642a31.23 31.23 0 002.253-11.685c0-17.289-14.015-31.304-31.304-31.304-4.131 0-8.074.8-11.685 2.253L91.927 76.648c.245-.189.485-.388.717-.596l11.234-11.235a12.098 12.098 0 017.426-3.078h17.392a12.095 12.095 0 017.426 3.078l11.235 11.235a12.095 12.095 0 007.426 3.078h17.391a13.044 13.044 0 0113.043 13.044v64.348a13.044 13.044 0 01-4.008 9.408l-32.158-32.158z","fill":"#BEBFC4"}}),_c('path',{attrs:{"stroke":"#BEBFC4","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M50.565 48.276l140.638 140.637"}})])
          )
        }
      }
    